export default __webpack_public_path__ + "static/strategy-back-f2fb94cbc2f384ee444fe2c118f66742.webp";